import type { InternalAxiosRequestConfig } from 'axios';
import { getCurrentOrgSlug } from '@src/shared/utils/get-org-id';
import { useAuthStore } from '@src/core/store/auth-store';

interface CustomAxiosRequestConfig extends InternalAxiosRequestConfig {
  withOrg?: boolean;
}

export const requestInterceptor = async (config: CustomAxiosRequestConfig) => {
  const { accessToken } = useAuthStore.getState();

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  if (accessToken && config.withOrg) {
    const orgSlug = getCurrentOrgSlug();
    if (orgSlug) {
      config.params = { ...(config.params || {}), organization: orgSlug };
    }
  }

  return config;
};
